var React = require('react');

function Chart (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M9.494 1.563H6.506a.463.463 0 00-.462.462v11.95c0 .255.207.463.462.463h2.988a.463.463 0 00.462-.463V2.025a.463.463 0 00-.462-.462zM4.357 7.537H1.37A.463.463 0 00.907 8v5.975c0 .255.207.463.463.463h2.987a.463.463 0 00.463-.463V8a.463.463 0 00-.463-.463zm7.286-2.987h2.987c.256 0 .463.207.463.463v8.962a.463.463 0 01-.463.463h-2.987a.463.463 0 01-.463-.463V5.013c0-.256.207-.463.463-.463z"}));
}

Chart.defaultProps = {"viewBox":"0 0 16 16"};

module.exports = Chart;

Chart.default = Chart;
